import { styled } from "@mui/material";
import { TABLET_SCREEN_SIZE, MOBILE_SCREEN_SIZE } from "../../utils/constants/Constants.js";
const ProductGrid = styled("div", {
  shouldForwardProp: (prop) => !["containerWidthOverride"].includes(prop.toString())
})(({ containerWidthOverride }) => ({
  display: "grid",
  gridTemplateColumns: `repeat(${containerWidthOverride ? 4 : 5}, 1fr)`,
  justifyContent: "space-between",
  gridGap: 20,
  [`@media screen and (max-width: ${1450}px)`]: {
    gridTemplateColumns: `repeat(4, 1fr)`
  },
  [`@media screen and (max-width: ${1150}px)`]: {
    gridTemplateColumns: `repeat(3, 1fr)`
  },
  [`@media screen and (max-width: ${(TABLET_SCREEN_SIZE + MOBILE_SCREEN_SIZE) / 2}px)`]: {
    gridTemplateColumns: `repeat(2, 1fr)`,
    gridGap: 10
  }
}));
export {
  ProductGrid
};
//# sourceMappingURL=SearchResultsStyles.js.map
